module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"data":"Date","maxValue":"Intensity"},"it":{"data":"Data","maxValue":"Intensità"}}')
  delete Component.options._Ctor
}
